<ion-app>
  @if (isMobileScreen()) {
    <div class="mobile-overlay">
      <img src="img/logo/logo.svg" class="mobile-overlay-logo" alt="logo" />
      <ion-text class="mobile-overlay-title">{{
        'installation_desktopOnlyTitle' | translate
      }}</ion-text>
      <ion-text class="mobile-overlay-message">
        {{ 'installation_desktopOnlyText' | translate }}
      </ion-text>
    </div>
  }
  @if (showOnlyRouterOutlet()) {
    <ion-router-outlet></ion-router-outlet>
  } @else {
    <ion-split-pane when="md" contentId="main-content">
      <ion-menu contentId="main-content" color="dark" class="remove-line">
        <ion-header class="main-menu-header bg-dark">
          <ion-toolbar color="dark">
            <ion-img src="img/logo/logo.svg" class="logo"></ion-img>
          </ion-toolbar>
        </ion-header>

        <ion-content color="dark">
          <ion-list class="ion-no-padding">
            <!-- dashboard menu item hidden, kept for future use
            <ion-item
              button
              routerLink="/dashboard"
              color="dark"
              routerDirection="root"
            >
              <ion-icon name="grid" slot="start"></ion-icon>
              <ion-label>{{ 'menu_dashboard' | translate }}</ion-label>
            </ion-item>
            -->
            <ion-item
              button
              routerLink="/installations"
              routerDirection="root"
              [class.menu-item-selected]="isInstallationsActive()"
            >
              <ion-icon name="home-outline" slot="start"></ion-icon>
              <ion-label>{{ 'menu_installations' | translate }}</ion-label>
            </ion-item>
            <ion-item
              button
              routerLink="/licenses"
              routerDirection="root"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="menu-item-selected"
            >
              <ion-icon name="key-outline" slot="start"></ion-icon>
              <ion-label>{{ 'menu_licenses' | translate }}</ion-label>
            </ion-item>
          </ion-list>
        </ion-content>
      </ion-menu>

      <div id="main-content" class="ion-page">
        <app-header></app-header>

        <ion-content color="light" class="ion-padding ion-content-full-height">
          <ion-router-outlet id="view" [animated]="false"></ion-router-outlet>
        </ion-content>
      </div>
    </ion-split-pane>
  }
</ion-app>
